import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import { getDatabase, ref, set } from "firebase/database";
import getFirebaseConfig from "./GetFirebaseConfig";

export default async function deleteUser(uid, user) {

    const app = getApp();
    const functions = getFunctions(app);
    const db = getDatabase();

    const deleteUser = httpsCallable(functions, "deleteUser");

    await deleteUser({ uid: uid })
    await set(ref(db, `users/${uid}`), null);

    if(user.retainer) {
        const promises = user.retainer?.map(item => new Promise( async resolve => {
            await set(ref(db, `retainerUsers/${item}/${uid}`), null);
            resolve(`Deleted user in retainer ${item}`);
        }));
        await Promise.all(promises);
    }
    
    return {
        status: 'success'
    }

}
